export default __webpack_public_path__ + "static/media/breakfast.d1eb6e3b.jpg";